<template>
  <div v-if="showPlaceholder" class="app-placeholder" :style="style">
    <i class="material-icons-outlined align-middle">apps</i>
  </div>
  <div v-else class="widget-item app-widget" :id="widget.object.wid" :style="style">
    <RssViewer
      v-if="widget.object.item_type === `app/${APP_TYPES.RSS}`"
      :setting="getRSSAppSettings(widget.object)"
    ></RssViewer>

    <TableAppWebView
      v-if="widget.object.item_type === `app/${APP_TYPES.TABLE}`"
      :settings="widget.object"
      :height="widget.position.heightPixels"
    ></TableAppWebView>

    <TrafiklabViewer
      v-if="widget.object.item_type === `app/${APP_TYPES.TRAFIKLAB}` && !hideApp"
      :viewerStyles="widget.object.viewerStyles"
      :timetable="widget.object.timetable"
      :appId="widget.object.item_id"
      :name="widget.object.name"
      alt="Trafiklab app"
      @error="showPlaceholder = true"
    />

    <WeatherView
      class="weather-app"
      v-else-if="isWeatherApp && !isOldWeatherApp"
      :app="widget.object"
    />

    <WeatherViewOld class="weather-app" v-else-if="isOldWeatherApp" :app="widget.object" />
  </div>
</template>

<script>
  import { APP_TYPES } from '@/models/layoutDesigner';
  import templateWidget from '@/components/templates/mixins/templateWidget';
  import { simpleTypeMixin } from '@/helpers';

  import RssViewer from '@/components/rssViewer/RssViewer.vue';
  import TableAppWebView from '@/components/tableApp/TableAppWebView.vue';
  import TrafiklabViewer from '@/components/common/timetable/TrafiklabViewer.vue';
  import WeatherView from '@/components/apps/weather/WeatherView.vue';
  import WeatherViewOld from '@/components/apps/weather/WeatherViewOld.vue';

  import { CONTENT_TYPE_WEATHER_APP } from '@/constant/const';

  export default {
    name: 'AppWidget',

    components: {
      RssViewer,
      TableAppWebView,
      TrafiklabViewer,
      WeatherView,
      WeatherViewOld,
    },

    mixins: [simpleTypeMixin, templateWidget],

    props: {
      widget: {
        type: Object,
      },
    },

    data() {
      return {
        APP_TYPES,
        showPlaceholder: false,
        hideApp: false,
      };
    },

    watch: {
      isPreview() {
        this.hideApp = true;

        const _this = this;

        setTimeout(function () {
          _this.hideApp = false;
        }, 1);
      },
    },

    computed: {
      style() {
        const style = this.defaultStyling(this.widget);

        return {
          ...style,
        };
      },

      isPreview() {
        return this.$store.state.player.isPreviewPlayer;
      },

      isOldWeatherApp() {
        return (
          this.isWeatherApp &&
          !this.widget.object.weather &&
          (this.widget.object.visibility || this.widget.object.background)
        );
      },

      isWeatherApp() {
        return this.widget.object.item_type === CONTENT_TYPE_WEATHER_APP;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .app-placeholder {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background-color: #fff;
    color: $secondaryText;
    overflow: hidden;

    i {
      font-size: 60px;
    }
  }

  .widget-item {
    position: absolute;
  }

  .rss-viewer {
    overflow: hidden;
  }

  .weather-app {
    width: 100%;
    height: 100%;
  }

  .app-widget {
    overflow: hidden;
  }
</style>
